/**
 * Skeleton de card de transportadora (manifiestos)
 */
import React from 'react'

const ManifiestoCarrierSkeleton: React.FC = () => {
  return (
    <div
      className="bg-white rounded-lg shadow-md border border-gray-200 p-6 animate-pulse"
      aria-hidden="true"
    >
      <div className="flex items-center space-x-3 mb-6">
        <div className="h-10 w-10 rounded-lg bg-gray-200" />
        <div className="flex-1 space-y-2">
          <div className="h-4 w-2/3 rounded bg-gray-200" />
          <div className="h-3 w-full rounded bg-gray-100" />
        </div>
      </div>
      <div className="mb-6 space-y-2">
        <div className="h-10 w-16 rounded bg-gray-200" />
        <div className="h-3 w-28 rounded bg-gray-100" />
      </div>
      <div className="h-10 w-full rounded-lg bg-gray-200" />
    </div>
  )
}

export default ManifiestoCarrierSkeleton
